// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__MYMVC","dayNight":"Toggle_dayNight__1KiJK"};